import isToBagInProgress from "./isToBagInProgress";
import isToBagComplete from "./isToBagComplete";

export default ({ itemState }) =>
  isToBagComplete({ itemState }) || isToBagInProgress({ itemState });
